import React from 'react'
import { Modal, Row, Col, Button } from 'antd'
import { CloseCircleFilled } from '@ant-design/icons'

import './style.scss'

const ModalV = props => {
  const { modalView, mask, modalWidth, modalType, modalDescription, handleClosePopup } = props
  const margintop = modalType === 'BOOK A MEETING' ? '-3%' : '2%'
  return (
    <div>
      <Modal
        title={false}
        width={modalWidth}
        visible={modalView}
        mask={mask}
        footer={null}
        closable={false}
        destroyOnClose
        className="main-modal"
        style={{ borderRadius: '7px', marginTop: margintop }}
        maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      >
        <Row>
          <Col span={24} style={{ textAlign: 'right', marginTop: '-13px', marginLeft: '8px' }}>
            <CloseCircleFilled
              className="gl-circle-close"
              onClick={() => handleClosePopup('close-popup')}
            />
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <div className="modal-title">{modalType}</div>
            <div className="modal-desc">{modalDescription}</div>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <Button
              type="link"
              className="btn-close"
              onClick={() => handleClosePopup('close-popup')}
            >
              <div style={{ textDecoration: 'underline' }}>Close pop up</div>
            </Button>
          </Col>
        </Row>
      </Modal>
    </div>
  )
}
export default ModalV
